import React from 'react';
import commentIcon from '../../img/icon_comment.png';
import { format } from "date-fns";

const CommentTable = ({ filteredComments, togglePopup }) => {

    const clickCommentBtn = (event) => {
        const dailyWorkId = event.target.getAttribute('data-id');
        const dailyMemo = event.target.getAttribute('daily-memo');
        togglePopup(dailyWorkId, dailyMemo);
    };

    return (
        <div className='wrapper'>
            <div>
                {filteredComments?.length > 0 ? (
                    <table className="table table-bordered" id="top_schedule-list" style={{ marginTop: 50 }}>
                        {filteredComments.map((commentList) => (
                            <tbody key={commentList.t_daily_work_id}>
                                <tr>
                                    <th style={{ backgroundColor: '#F8F8F8' }}>
                                        <span style={{ color: '#999999' }}>
                                            By mamemo on {commentList.work_date}
                                        </span>
                                        <br />
                                        <div className="nameBox" key={commentList.dairy_user_id} style={{ marginTop: 15 }}>
                                            <span className={`statusicon sta-icon${commentList.dairy_icon_num}`} />
                                            &nbsp;&nbsp;
                                            <a href={`/scheduleDownload/${commentList.dairy_user_id}`}>
                                                {commentList.dairy_user_name}
                                            </a>
                                        </div>
                                    </th>
                                    <td className="mamemo" style={{ color: '#999999' }}>
                                        <div className="comment" style={{ position: "absolute", left: 12, top: 8 }}>
                                            {commentList.daily_memo_comment}
                                        </div>
                                        <div style={{ position: "absolute", left: 12, bottom: 8 }}>
                                            Posted on {format(new Date(commentList.ins_datetime), "yyyy/MM/dd")}
                                        </div>
                                        <div className="comment_btn">
                                            <img
                                                src={commentIcon}
                                                alt="Comment"
                                                data-btntag="2"
                                                data-id={commentList.t_daily_work_id}
                                                daily-memo={commentList.daily_memo_comment}
                                                className="jq-mame-comment-popup"
                                                onClick={clickCommentBtn}
                                            />
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        ))}
                    </table>
                ) : (
                    <p>No comments found</p>
                )}
            </div>
        </div>
    );
};

export default CommentTable;
